export default __webpack_public_path__ + "static/media/desktop_81.ea3d156e.jpg";